import Styles from 'src/components/Styles';

export function getStyleWithColorOnly(): {[index: string]: string} {
  return {
    backgroundColor: '#84BD0029',
    color: Styles.Colors.CompanyKitchen.black,
    allReadTextUnderLine: Styles.footerTabActive,
  };
}

export function snackBarColorDescriptor(): string {
  return Styles.Colors.CompanyKitchen.green;
}

export function getToastTextStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    allReadText: {
      fontSize: Styles.Fonts.f1,
      paddingTop: Styles.Spacing.m1,
      color: Styles.footerTabActive,
      fontFamily: Styles.FontFamily.latoRegular,
      fontWeight: '700',
    },
  };
}

export function getRightReadMarkIconColor(): string {
  return null;
}

export function snackBarFontFamily(): string {
  return Styles.FontFamily.latoRegular;
}

export function cartToastViewStyle() {
  return {
    backgroundColor: Styles.Colors.Canteen.toastBackgroundColor,
    borderColor: Styles.Colors.Canteen.green,
  };
}

export function cartToastTextStyle() {
  return {
    color: Styles.tabBarTextColor,
  };
}

export default {
  getStyleWithColorOnly,
  snackBarColorDescriptor,
  getToastTextStyleDescriptor,
  getRightReadMarkIconColor,
  snackBarFontFamily,
  cartToastViewStyle,
  cartToastTextStyle,
};
